import { render, staticRenderFns } from "./ProductWrhousngRegistration.vue?vue&type=template&id=dd2c0216&scoped=true&"
import script from "./ProductWrhousngRegistration.vue?vue&type=script&lang=js&"
export * from "./ProductWrhousngRegistration.vue?vue&type=script&lang=js&"
import style0 from "./ProductWrhousngRegistration.vue?vue&type=style&index=0&id=dd2c0216&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd2c0216",
  null
  
)

export default component.exports